module.exports = __webpack_public_path__ + "static/media/FamilyFriends.2097c8fe.svg";